import { Component, OnInit } from '@angular/core';
import {DataService} from '../../services/data.service';
import { normalizeCategoryTitleDivHeights} from '../globals/globals.component';
import { deactiveNullAnchors } from '../globals/globals.component';

@Component({
  selector: 'app-microwebsites',
  templateUrl: './microwebsites.component.html',
  styleUrls: ['./microwebsites.component.css']
})
export class MicrowebsitesComponent implements OnInit {
  postsData:any[];
  posts:Post[];
  public normalizeCategoryTitleDivHeights = normalizeCategoryTitleDivHeights;
  public deactiveNullAnchors = deactiveNullAnchors;
  
  constructor(private dataService:DataService) { 
    
  }
 
  ngOnInit() {
    this.dataService.getPosts("microsites").subscribe((post)=>{
      console.log(post);
      this.posts=post;
      this.postsData = this.posts;
    });
  }

  ngAfterViewInit() { 
  }
  
setClickClass(theanchor: HTMLAnchorElement) {
  let hideLink:boolean = false;
  console.log(theanchor.href);
  let theLink:string = theanchor.href;
  if(theLink.indexOf("nolink")>-1) hideLink=true;
  //console.log(hideLink);
  let classes = {
    'click-through-off' : hideLink
  }
  return classes;
}



}

interface AfterViewInit { 
  ngAfterViewInit(): void
}

interface Post {

}



// WEBPACK FOOTER //
// C:/Users/calvi/Documents/AngularProjects/calvinparksportfolio/src/app/components/microwebsites/microwebsites.component.ts